import { i as qm } from "./index-358d3985.js";
import { i as Zm } from "./index-d76a0c7f.js";
import { ClockUpdate as t } from "./ford_credit_clockUpdate.js";
import { ArrowRight as P } from "./ford_credit_arrowRight.js";
import { CancelClose as L } from "./ford_credit_cancelClose.js";
import { CaretRight as D } from "./ford_credit_caretRight.js";
import { Lock as A } from "./ford_credit_lock.js";
import { Document as e } from "./ford_credit_document.js";
import { Warning as R } from "./ford_credit_warning.js";
import { Add as b } from "./ford_credit_add.js";
import { CaretLeft as I } from "./ford_credit_caretLeft.js";
import { Bell as i } from "./ford_credit_bell.js";
import { Checkmark as U } from "./ford_credit_checkmark.js";
import { Payment as m } from "./ford_credit_payment.js";
import { CaretUp as O } from "./ford_credit_caretUp.js";
import { Information as M } from "./ford_credit_information.js";
import { VehicleTop as s } from "./ford_credit_vehicleTop.js";
import { FileSearch as l } from "./ford_credit_fileSearch.js";
import { File as g } from "./ford_credit_file.js";
import { CalendarDate as p } from "./ford_credit_calendarDate.js";
import { FileCheck as n } from "./ford_credit_fileCheck.js";
import { ArrowDown as B } from "./ford_credit_arrowDown.js";
import { StatusOff as f } from "./ford_credit_statusOff.js";
import { ArrowUp as T } from "./ford_credit_arrowUp.js";
import { DoorOpen as S } from "./ford_credit_doorOpen.js";
import { StatusOn as v } from "./ford_credit_statusOn.js";
import { Profile as E } from "./ford_credit_profile.js";
import { ArrowLeft as G } from "./ford_credit_arrowLeft.js";
import { Balloon as c } from "./ford_credit_balloon.js";
import { Calculator as x } from "./ford_credit_calculator.js";
import { CalendarRepeat as d } from "./ford_credit_calendarRepeat.js";
import "react/jsx-runtime";
import { AutoPay as u } from "./ford_credit_autoPay.js";
import { Vehicle as C } from "./ford_credit_vehicle.js";
import { Printer as h } from "./ford_credit_printer.js";
import { Close as F } from "./ford_credit_close.js";
import { FordCreditLogo as r } from "./ford_credit_fordCreditLogo.js";
import { Gauge as k } from "./ford_credit_gauge.js";
import { CheckmarkRounded as N } from "./ford_credit_checkmarkRounded.js";
import { Bank as w } from "./ford_credit_bank.js";
import { CaretDown as V } from "./ford_credit_caretDown.js";
import { Contacts as y } from "./ford_credit_contacts.js";
import { Settings as $ } from "./ford_pro_settings.js";
import { ChargeStatusCharging as z } from "./ford_pro_chargeStatusCharging.js";
import { Cart as W } from "./ford_pro_cart.js";
import { Gallery as H } from "./ford_pro_gallery.js";
import { Download as K } from "./ford_pro_download.js";
import { Expand as q } from "./ford_pro_expand.js";
import { ArrowRight as Q } from "./ford_pro_arrowRight.js";
import { Volume as Z } from "./ford_pro_volume.js";
import { CancelClose as X } from "./ford_pro_cancelClose.js";
import { CaretRight as Y } from "./ford_pro_caretRight.js";
import { Lock as j } from "./ford_pro_lock.js";
import { PinEmpty as J } from "./ford_pro_pinEmpty.js";
import { CcpaOptOut as _ } from "./ford_pro_ccpaOptOut.js";
import { X as rr } from "./ford_pro_x.js";
import { OnOff as or } from "./ford_pro_onOff.js";
import { DeleteAll as ar } from "./ford_pro_deleteAll.js";
import { Instagram as tr } from "./ford_pro_instagram.js";
import { RefreshFilled as er } from "./ford_pro_refreshFilled.js";
import { Link as ir } from "./ford_pro_link.js";
import { LtuLithuania as mr } from "./ford_pro_ltuLithuania.js";
import { Suv as sr } from "./ford_pro_suv.js";
import { CheSwitzerland as lr } from "./ford_pro_cheSwitzerland.js";
import { CypCyprus as gr } from "./ford_pro_cypCyprus.js";
import { InformationFilled as pr } from "./ford_pro_informationFilled.js";
import { Bluetooth as nr } from "./ford_pro_bluetooth.js";
import { Warning as fr } from "./ford_pro_warning.js";
import { Email as Sr } from "./ford_pro_email.js";
import { Add as vr } from "./ford_pro_add.js";
import { ChargeStatusFault as cr } from "./ford_pro_chargeStatusFault.js";
import { CaretLeft as dr } from "./ford_pro_caretLeft.js";
import { CanCanada as ur } from "./ford_pro_canCanada.js";
import { MoreVertical as Cr } from "./ford_pro_moreVertical.js";
import { Collapse as hr } from "./ford_pro_collapse.js";
import { Battery as Fr } from "./ford_pro_battery.js";
import { Icon as kr } from "./ford_pro_icon.js";
import { Troubleshoot as wr } from "./ford_pro_troubleshoot.js";
import { CaretRightFilled as yr } from "./ford_pro_caretRightFilled.js";
import { CaretDownFilled as Pr } from "./ford_pro_caretDownFilled.js";
import { AutAustria as Lr } from "./ford_pro_autAustria.js";
import { CzeCzechia as Dr } from "./ford_pro_czeCzechia.js";
import { GbrUntedKingdom as Ar } from "./ford_pro_gbrUntedKingdom.js";
import { LvaLatvia as Rr } from "./ford_pro_lvaLatvia.js";
import { MltMalta as br } from "./ford_pro_mltMalta.js";
import { Circle as Ir } from "./ford_pro_circle.js";
import { Home as Ur } from "./ford_pro_home.js";
import { EstEstonia as Or } from "./ford_pro_estEstonia.js";
import { Search as Mr } from "./ford_pro_search.js";
import { Checkmark as o } from "./ford_pro_checkmark.js";
import { Transfer as Br } from "./ford_pro_transfer.js";
import { List as Tr } from "./ford_pro_list.js";
import { Equipment as Er } from "./ford_pro_equipment.js";
import { BgrBulgaria as Gr } from "./ford_pro_bgrBulgaria.js";
import { CaretUp as xr } from "./ford_pro_caretUp.js";
import { Information as Nr } from "./ford_pro_information.js";
import { BatteryCharging as Vr } from "./ford_pro_batteryCharging.js";
import { Show as $r } from "./ford_pro_show.js";
import { ShowOnMap as zr } from "./ford_pro_showOnMap.js";
import { FordProLogo as a } from "./ford_pro_fordProLogo.js";
import { Recent as Wr } from "./ford_pro_recent.js";
import { ShareIOs as Hr } from "./ford_pro_shareIOs.js";
import { FavouriteFilled as Kr } from "./ford_pro_favouriteFilled.js";
import { Clear as qr } from "./ford_pro_clear.js";
import { NotificationFilled as Qr } from "./ford_pro_notificationFilled.js";
import { ArrowDown as Zr } from "./ford_pro_arrowDown.js";
import { DeuGermany as Xr } from "./ford_pro_deuGermany.js";
import { LockUnlock as Yr } from "./ford_pro_lockUnlock.js";
import { Address as jr } from "./ford_pro_address.js";
import { CaretLeftFilled as Jr } from "./ford_pro_caretLeftFilled.js";
import { ChargeStation as _r } from "./ford_pro_chargeStation.js";
import { Favourite as ro } from "./ford_pro_favourite.js";
import { PrtPortugal as oo } from "./ford_pro_prtPortugal.js";
import { Sorting as ao } from "./ford_pro_sorting.js";
import { GrcGreece as to } from "./ford_pro_grcGreece.js";
import { Sort as eo } from "./ford_pro_sort.js";
import { Video as io } from "./ford_pro_video.js";
import { Undo as mo } from "./ford_pro_undo.js";
import { LinkedIn as so } from "./ford_pro_linkedIn.js";
import { Calendar as lo } from "./ford_pro_calendar.js";
import { NorNorway as go } from "./ford_pro_norNorway.js";
import { Filter as po } from "./ford_pro_filter.js";
import { EspSpain as no } from "./ford_pro_espSpain.js";
import { ArrowUp as fo } from "./ford_pro_arrowUp.js";
import { MapView as So } from "./ford_pro_mapView.js";
import { Cloud as vo } from "./ford_pro_cloud.js";
import { Cut as co } from "./ford_pro_cut.js";
import { CaretUpFilled as uo } from "./ford_pro_caretUpFilled.js";
import { CancelCloseFilled as Co } from "./ford_pro_cancelCloseFilled.js";
import { Clock as ho } from "./ford_pro_clock.js";
import { Delete as Fo } from "./ford_pro_delete.js";
import { MoreHorizontal as ko } from "./ford_pro_moreHorizontal.js";
import { Webex as wo } from "./ford_pro_webex.js";
import { Phone as yo } from "./ford_pro_phone.js";
import { Location as Po } from "./ford_pro_location.js";
import { NotificationAlert as Lo } from "./ford_pro_notificationAlert.js";
import { TurTurkey as Do } from "./ford_pro_turTurkey.js";
import { Share as Ao } from "./ford_pro_share.js";
import { Profile as Ro } from "./ford_pro_profile.js";
import { Car as bo } from "./ford_pro_car.js";
import { UsaUnitedStates as Io } from "./ford_pro_usaUnitedStates.js";
import { PopUp as Uo } from "./ford_pro_popUp.js";
import { Van as Oo } from "./ford_pro_van.js";
import { TikTok as Mo } from "./ford_pro_tikTok.js";
import { Timer as Bo } from "./ford_pro_timer.js";
import { Users as To } from "./ford_pro_users.js";
import { RemoveFavourite as Eo } from "./ford_pro_removeFavourite.js";
import { Print as Go } from "./ford_pro_print.js";
import { NldNetherlands as xo } from "./ford_pro_nldNetherlands.js";
import { IrlIreland as No } from "./ford_pro_irlIreland.js";
import { FraFrance as Vo } from "./ford_pro_fraFrance.js";
import { Fpo as $o } from "./ford_pro_fpo.js";
import { SweSweden as zo } from "./ford_pro_sweSweden.js";
import { Pause as Wo } from "./ford_pro_pause.js";
import { ArrowLeft as Ho } from "./ford_pro_arrowLeft.js";
import { ShareAndroid as Ko } from "./ford_pro_shareAndroid.js";
import { ZoomOut as qo } from "./ford_pro_zoomOut.js";
import { Company as Qo } from "./ford_pro_company.js";
import { Print1 as Zo } from "./ford_pro_print1.js";
import { Calculator as Xo } from "./ford_pro_calculator.js";
import { Menu as Yo } from "./ford_pro_menu.js";
import { Pushpin as jo } from "./ford_pro_pushpin.js";
import { PinDot as Jo } from "./ford_pro_pinDot.js";
import { WarningFilled as _o } from "./ford_pro_warningFilled.js";
import { Csv as ra } from "./ford_pro_csv.js";
import { Browse as oa } from "./ford_pro_browse.js";
import { CheckmarkFilled as aa } from "./ford_pro_checkmarkFilled.js";
import { ChargeFault as ta } from "./ford_pro_chargeFault.js";
import { DecreaseFilled as ea } from "./ford_pro_decreaseFilled.js";
import { Play as ia } from "./ford_pro_play.js";
import { RouRomania as ma } from "./ford_pro_rouRomania.js";
import { CarFront as sa } from "./ford_pro_carFront.js";
import { SvkSlovakia as la } from "./ford_pro_svkSlovakia.js";
import { Notification as ga } from "./ford_pro_notification.js";
import { Camera as pa } from "./ford_pro_camera.js";
import { PlayFilled as na } from "./ford_pro_playFilled.js";
import { ClosedCaptions as fa } from "./ford_pro_closedCaptions.js";
import { Facebook as Sa } from "./ford_pro_facebook.js";
import { Subtract as va } from "./ford_pro_subtract.js";
import { Copy as ca } from "./ford_pro_copy.js";
import { Image as da } from "./ford_pro_image.js";
import { Hide as ua } from "./ford_pro_hide.js";
import { Refresh as Ca } from "./ford_pro_refresh.js";
import { ItaItaly as ha } from "./ford_pro_itaItaly.js";
import { ZoomIn as Fa } from "./ford_pro_zoomIn.js";
import { Edit as ka } from "./ford_pro_edit.js";
import { DnkDenmark as wa } from "./ford_pro_dnkDenmark.js";
import { Youtube as ya } from "./ford_pro_youtube.js";
import { CarInformation as Pa } from "./ford_pro_carInformation.js";
import { RemoveFavouriteFilled as La } from "./ford_pro_removeFavouriteFilled.js";
import { Thread as Da } from "./ford_pro_thread.js";
import { LineChart as Aa } from "./ford_pro_lineChart.js";
import { Pdf as Ra } from "./ford_pro_pdf.js";
import { MexMexico as ba } from "./ford_pro_mexMexico.js";
import { QuestionMark as Ia } from "./ford_pro_questionMark.js";
import { CaretDown as Ua } from "./ford_pro_caretDown.js";
import { Google as Oa } from "./ford_pro_google.js";
import { PolPoland as Ma } from "./ford_pro_polPoland.js";
import { GlobalKeyboard as Ba } from "./ford_pro_globalKeyboard.js";
import { Groups as Ta } from "./ford_pro_groups.js";
import { MapLayer as Ea } from "./ford_pro_mapLayer.js";
import { Truck as Ga } from "./ford_pro_truck.js";
import { Mute as xa } from "./ford_pro_mute.js";
import { Paste as Na } from "./ford_pro_paste.js";
import { ChargeStatusNotCharging as Va } from "./ford_pro_chargeStatusNotCharging.js";
import { BluetoothBrand as $a } from "./ford_pro_bluetoothBrand.js";
import { BarChart as za } from "./ford_pro_barChart.js";
import { FinFinland as Wa } from "./ford_pro_finFinland.js";
import { SvnSlovenia as Ha } from "./ford_pro_svnSlovenia.js";
import { QuestionMarkFilled as Ka } from "./ford_pro_questionMarkFilled.js";
import { E as Ym, S as jm } from "./icons.types-0722eef5.js";
import "./ford_credit_checkmarkFilled.js";
import "./ford_pro_oldPlay.js";
import "./ford_pro_oldPause.js";
import "./ford_pro_upload.js";
const zm = {
  add: vr,
  address: jr,
  arrowDown: Zr,
  arrowLeft: Ho,
  arrowRight: Q,
  arrowUp: fo,
  barChart: za,
  battery: Fr,
  batteryCharging: Vr,
  bluetooth: nr,
  bluetoothBrand: $a,
  browse: oa,
  calculator: Xo,
  calendar: lo,
  camera: pa,
  cancelClose: X,
  cancelCloseFilled: Co,
  car: bo,
  caretDown: Ua,
  caretDownFilled: Pr,
  caretLeft: dr,
  caretLeftFilled: Jr,
  caretRight: Y,
  caretRightFilled: yr,
  caretUp: xr,
  caretUpFilled: uo,
  carFront: sa,
  carInformation: Pa,
  cart: W,
  ccpaOptOut: _,
  chargeFault: ta,
  chargeStation: _r,
  chargeStatusCharging: z,
  chargeStatusFault: cr,
  chargeStatusNotCharging: Va,
  checkmark: o,
  checkmarkFilled: aa,
  circle: Ir,
  clear: qr,
  clock: ho,
  closedCaptions: fa,
  cloud: vo,
  company: Qo,
  collapse: hr,
  copy: ca,
  csv: ra,
  cut: co,
  decreaseFilled: ea,
  delete: Fo,
  deleteAll: ar,
  download: K,
  edit: ka,
  email: Sr,
  equipment: Er,
  expand: q,
  facebook: Sa,
  favourite: ro,
  favouriteFilled: Kr,
  filter: po,
  fordProLogo: a,
  fpo: $o,
  logo: a,
  gallery: H,
  globalKeyboard: Ba,
  groups: Ta,
  google: Oa,
  hide: ua,
  home: Ur,
  icon: kr,
  image: da,
  information: Nr,
  informationFilled: pr,
  instagram: tr,
  lineChart: Aa,
  linkedIn: so,
  link: ir,
  list: Tr,
  location: Po,
  lock: j,
  lockUnlock: Yr,
  mapLayer: Ea,
  mapView: So,
  menu: Yo,
  moreHorizontal: ko,
  moreVertical: Cr,
  mute: xa,
  notification: ga,
  notificationAlert: Lo,
  notificationFilled: Qr,
  onOff: or,
  paste: Na,
  pause: Wo,
  pdf: Ra,
  phone: yo,
  pinDot: Jo,
  pinEmpty: J,
  play: ia,
  playFilled: na,
  popUp: Uo,
  print: Go,
  print1: Zo,
  profile: Ro,
  pushPin: jo,
  questionMark: Ia,
  questionMarkFilled: Ka,
  recent: Wr,
  refresh: Ca,
  refreshFilled: er,
  removeFavourite: Eo,
  removeFavouriteFilled: La,
  search: Mr,
  settings: $,
  share: Ao,
  shareAndroid: Ko,
  shareIOs: Hr,
  show: $r,
  showOnMap: zr,
  sort: eo,
  subtract: va,
  suv: sr,
  thread: Da,
  tikTok: Mo,
  timer: Bo,
  transfer: Br,
  truck: Ga,
  troubleshoot: wr,
  sorting: ao,
  undo: mo,
  users: To,
  van: Oo,
  video: io,
  volume: Z,
  warning: fr,
  warningFilled: _o,
  webex: wo,
  x: rr,
  youtube: ya,
  zoomIn: Fa,
  zoomOut: qo,
  checkmarkRounded: o,
  austriaFlag: Lr,
  bulgariaFlag: Gr,
  canadaFlag: ur,
  switzerlandFlag: lr,
  cyprusFlag: gr,
  czechiaFlag: Dr,
  germanyFlag: Xr,
  denmarkFlag: wa,
  spainFlag: no,
  estoniaFlag: Or,
  finlandFlag: Wa,
  franceFlag: Vo,
  unitedKingdomFlag: Ar,
  greeceFlag: to,
  irelandFlag: No,
  italyFlag: ha,
  lithuaniaFlag: mr,
  latviaFlag: Rr,
  mexicoFlag: ba,
  maltaFlag: br,
  netherlandsFlag: xo,
  norwayFlag: go,
  polandFlag: Ma,
  portugalFlag: oo,
  romaniaFlag: ma,
  slovakiaFlag: la,
  sloveniaFlag: Ha,
  swedenFlag: zo,
  turkeyFlag: Do,
  unitedStatesFlag: Io,
  // -- Icons for Credit Support --
  autoPay: u,
  balloon: c,
  bank: w,
  bell: i,
  calendarDate: p,
  calendarRepeat: d,
  clockUpdate: t,
  close: F,
  contacts: y,
  document: e,
  doorOpen: S,
  file: g,
  fileCheck: n,
  fileSearch: l,
  fordCreditLogo: r,
  gauge: k,
  payment: m,
  printer: h,
  statusOff: f,
  statusOn: v,
  vehicle: C,
  vehicleTop: s
}, Wm = {
  add: b,
  arrowDown: B,
  arrowLeft: G,
  arrowRight: P,
  arrowUp: T,
  autoPay: u,
  balloon: c,
  bank: w,
  bell: i,
  calculator: x,
  calendarDate: p,
  calendarRepeat: d,
  cancelClose: L,
  caretDown: V,
  caretLeft: I,
  caretRight: D,
  caretUp: O,
  checkmark: U,
  checkmarkRounded: N,
  clockUpdate: t,
  close: F,
  contacts: y,
  document: e,
  doorOpen: S,
  file: g,
  fileCheck: n,
  fileSearch: l,
  fordCreditLogo: r,
  gauge: k,
  information: M,
  lock: A,
  payment: m,
  printer: h,
  profile: E,
  statusOff: f,
  statusOn: v,
  vehicle: C,
  vehicleTop: s,
  warning: R,
  logo: r
};
export {
  Ym as ExtendedSizes,
  Wm as FordCreditIcons,
  zm as FordProIcons,
  jm as Sizes,
  qm as creditIcons,
  Zm as fordProIcons
};
